window.dataLayer = window.dataLayer || [];
class gTagEvents {
    constructor() {
        this.delegateBody = new Delegate(document.body);

        this.bindEvents();
        this.observeDOMChanges();
        this.handleIntersects();
        this.setTrackingConsentCookie();

        this.interceptCartApi();
    }

    bindEvents() {
        this.delegateBody.on("click", "button[name='checkout']", this.handleCheckout.bind(this));
        this.delegateBody.on("click", '[data-action="ga-send-select"]', this.handleSelectItem.bind(this));
        this.delegateBody.on('variant:changed:gtm', this.handleVariantChange.bind(this));
        document.addEventListener('click', (event) => {
            const button = event.target.closest('[data-action="add-to-cart"]');
            if (!button) return;

            // Check if it's cart drawer upsell
            const isCartUpsell = button.closest('.cart-drawer__rec-item') ||
                                button.closest('.cart-drawer__recommendations') ||
                                button.closest('.cd__recommendations--desktop');

            if (isCartUpsell) {
                this.handleCartUpsellAddToCart(event);
                return;
            }

            // Check if it's PDP upsell
            const isPDPUpsell = button.closest('.product-info__complementary') ||
                               button.closest('.product-info__block');
            if (isPDPUpsell) {
                this.handlePDPUpsellAddToCart(event);
                return;
            }
        });

        document.addEventListener('click', (event) => {
            const image = event.target.closest('.product-card__image');
            if (!image) return;

            const isCartUpsell = image.closest('.cd__recommendations--desktop') ||
                                image.closest('.cart-drawer__recommendations');
            if (!isCartUpsell) return;

            this.handleCartUpsellImageClick(event);
        });

    }

    observeDOMChanges() {
        const observer = new MutationObserver((mutationsList, observer) => {
            // For each mutation record, we look for added nodes
            for (const mutation of mutationsList) {
                if (mutation.addedNodes.length) {
                    // If there are added nodes, we call handleIntersects to check for new items
                    this.handleIntersects();
                }
            }
        });

        // Start observing the document body for added nodes and subtree modifications
        observer.observe(document.body, {
            childList: true, // Observe direct children
            subtree: true, // and all descendants
            attributes: false // Set to true if you also want to observe attribute changes
        });
    }

    setTrackingConsentCookie() { 
        const existingCookie = document.cookie.split(';').find(c => c.trim().startsWith('_tracking_consent'));
        if (existingCookie) {
            console.log('[CONSENT] Cookie already exists');
            return;
        }
        
        const updateCookie = (detail) => {     
            if (!detail) {
                console.log('[CONSENT] No detail - aborting');
                return;
            }
            
            const functional = detail.preferencesAllowed;
            const analytics = detail.analyticsAllowed;
            const marketing = detail.marketingAllowed;
            
            let flag = '0';
            flag += functional ? 'F' : 'f';
            flag += analytics ? 'A' : 'a';
            flag += marketing ? 'M' : 'm';
            
            const cookieValue = `${flag}.0`;
            const expires = new Date();
            expires.setFullYear(expires.getFullYear() + 1);
            const cookieString = `_tracking_consent=${cookieValue}; path=/; SameSite=Lax; Secure; expires=${expires.toUTCString()}`;
            
            document.cookie = cookieString;
        };
        
        if (window.Shopify?.customerPrivacy?.currentVisitorConsent()) {
            updateCookie(window.Shopify.customerPrivacy.currentVisitorConsent());
        }
        
        document.addEventListener('visitorConsentCollected', (event) => {
            updateCookie(event.detail);
        });
    }

    handleIntersects() {
        const allIntersections = document.body.querySelectorAll('[data-gtag-intersection][data-observed="false"]');

        allIntersections.forEach((item) => {
            const observer = new IntersectionObserver(
                this.handleIntersection.bind(this),
                {
                    root: null, // Use the viewport as the root
                    rootMargin: "0px",
                    threshold: 0.1, // Adjust the threshold as per your requirement
                }
            );

            observer.observe(item);
            item.dataset.observed = "true";
        });
    }

    handleIntersection(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                let data = false;

                try {
                    data = JSON.parse(
                        entry.target.querySelector('script[type="application/ld+json"]').textContent
                    );

                } catch (e) {
                    console.log("JSON parse failed", e);
                }

                if (!dataLayer || !data) return;

                dataLayer.push({ ecommerce: null });
                dataLayer.push(data);

                console.log(data, "And pushed to dataLayer");
            }
        });
    }

    // check if okay
    // how we fetch current variant can vary depending on the theme
    handleVariantChange(event) {        
        // get current variant id from url
        const params = new URLSearchParams(window.location.search);
        const variantIdParam = params.get("variant");
    
        if (!variantIdParam) return;
        const currentVariantID = Number(variantIdParam);
    
        // find current variant json in ShopifyAnalytics
        const variants = ShopifyAnalytics.meta.product.variants;
        let currentVariant = null;
    
        variants.forEach(variant => {        
            if (variant.id === currentVariantID) currentVariant = variant;
        })
    
        // get and update gtm script
        const dataElem = document.querySelector('.main-product__gtm-script');    
        if (!currentVariant || !dataElem) return;
        
        const data = JSON.parse(dataElem.textContent);
        const item = data.ecommerce.items[0];
        
        item.item_variant = currentVariant.public_title || "Default Title";
        item.item_id = currentVariant.id || "";
        item.item_sku = currentVariant.sku || "";
        item.price = currentVariant.price / 100;
        item.quantity = 1;
    
        data.ecommerce.value = currentVariant.price / 100;
    
        if (!dataLayer || !data) return;
    
        dataLayer.push({ ecommerce: null });
        dataLayer.push(data);
        console.log(data, "And pushed to dataLayer");
    }

    interceptCartApi() {
        const originalFetch = window.fetch;
        const _this = this;

        window.fetch = async function (...args) {
            try {
                const [url, request] = [...args];

                // Trigger custom logic for cart clear API
                if (url.includes(`/cart/clear`)) _this.cartClear();
                if (url.includes(`/cart/update`)) _this.cartUpdate(request.body);

                const response = await originalFetch.apply(this, args);
                if (!response.ok) return response;
                
                 // Early return for non-cart-related APIs or missing conditions
                 if (url === '' || !dataLayer) return response;             

                // Process cart actions based on URL
                if (url.includes(`/cart/add`)) {
                    const responseClone = response.clone();
                    const json = await responseClone.json(); 

                    _this.cartAdd(json, request);
                } else if (url.includes(`/cart/change`)) {
                    const responseClone = response.clone();
                    const json = await responseClone.json(); 

                    _this.cartChange(json);
                }

                return response;

            } catch (e) {
                console.error('Fetch interceptor error:', e);
                return originalFetch(...args);
            }
        };
    }

    // check if quantity is okay
    // when adding product that already exist in a cart fetch response thats returned does not have right product quantity
    // instead of showing how many products has been added it shows how many there are in cart
    async cartAdd(cart, request) {
        let cartItems = cart.items ? cart.items : [cart];
        cartItems = this.getDataFromRequest(cartItems, request);
        this.productAdded(cartItems);
    }

    async cartUpdate(body) {
        if (!body) return;
        const updates = JSON.parse(body).updates;
    
        const oldCart = await this.getCart();
        const cartItems = oldCart.items, itemsAdded = [], itemsRemoved = [];
    
        cartItems.forEach(item => {            
            const newQuantity = updates[item.key];
            if (typeof newQuantity === "number") {
                const change = newQuantity - item.quantity;
                item.quantity = Math.abs(change);
    
                change < 1 ? itemsRemoved.push(item) : itemsAdded.push(item);
            }
        })
    
        this.productAdded(itemsAdded);
        this.productsRemoved(itemsRemoved);
    }

    async cartChange(cart) {
        this.productAdded(cart.items_added);
        this.productsRemoved(cart.items_removed);
    }

    async cartClear() {
        const cart = await this.getCart();
        this.productsRemoved(cart.items);
    }

    async getCart() {
        try {
            const response = await fetch(window.routes.localeRootUrl + "/cart.js", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            });

            return await response.json();

        } catch (error) {
            console.log('Fetch Error:', error);
        }
    }

    productAdded(cartItems) {
        if (!cartItems || !cartItems.length) return;

        const customEvent = {
            'event': 'custom_add_to_cart',
            'ecommerce': this.buildEcommerce(cartItems)
        }

        dataLayer.push({ ecommerce: null });
        dataLayer.push(customEvent);
        console.log("dataLayer push -> custom_add_to_cart:", customEvent);
    }

    async productsRemoved(cartItems) {
        if (!cartItems || !cartItems.length) return;

        const customEvent = {
              'event': "remove_from_cart",
              'ecommerce': this.buildEcommerce(cartItems)
        }
  
        dataLayer.push({ ecommerce: null });
        dataLayer.push(customEvent);
        console.log("dataLayer push -> remove_from_cart:", customEvent);
    }

    handleCheckout() {
        const button = event.target.closest("button[name='checkout']");
        if (!button) return;

        const script = button.parentElement.querySelector('[type="application/ld+json"]');
        const settings = JSON.parse(script.innerText);

        if (!dataLayer || !settings) return;

        dataLayer.push({ ecommerce: null });
        dataLayer.push(settings);

        console.log("dataLayer push -> checkoutFired:", settings);
    }

    handleSelectItem(event) {
        let target = event.target.closest('[data-action="ga-send-select"]');
        if (!target || !dataLayer) return;

        const settings = JSON.parse(target.dataset.selectSettings);
        if (!settings) return;

        const customEvent = {
            event: "custom_select_item",
            ecommerce: {
                selected_item_list_id: settings.list_id,
                selected_item_list_name: settings.list_name,
                currency: ShopifyAnalytics.meta.currency,
                items: [settings]
            }
        }

        dataLayer.push({ ecommerce: null });
        dataLayer.push(customEvent);
        console.log("dataLayer push -> custom_select_item:", customEvent);
    }

    handleCartUpsellImageClick(event) {
        if (!dataLayer) return;

        const image = event.target.closest('.product-card__image');
        if (!image) return;

        // Find the product card link that contains the GTM data
        const productLink = image.closest('[data-action="ga-send-select"]');
        if (!productLink) return;

        const settings = JSON.parse(productLink.dataset.selectSettings);
        if (!settings) return;

        // Get the product card to extract additional data
        const productCard = image.closest('.cart-drawer__rec-item') ||
                           image.closest('.swiper-slide') ||
                           image.closest('.product-card');

        // Extract product title
        const productTitle = productCard?.querySelector('.product-card__title')?.textContent?.trim() || settings.item_name || '';

        // Extract price - try multiple methods
        let price = 0;

        // First, try to get from settings
        if (settings?.price && settings.price > 0) {
            price = settings.price;
        } else {
            // Fallback: extract from DOM
            const priceElement = productCard?.querySelector('.priceItem--regular');
            if (priceElement) {
                // Parse formatted price like "$29.95" or "29.95"
                const priceText = priceElement.textContent.trim();
                const priceMatch = priceText.match(/[\d,]+\.?\d*/);
                if (priceMatch) {
                    price = parseFloat(priceMatch[0].replace(/,/g, ''));
                }
            }
        }

        // Extract product ID from the form
        const form = productCard?.querySelector('form');
        const productId = form?.dataset?.productid || settings.item_id || '';

        const customEvent = {
            event: 'cart_upsell_module_image',
            ecommerce: {
                currency: ShopifyAnalytics.meta.currency,
                item_list_id: settings.list_id,
                item_list_name: settings.list_name,
                items: [{
                    list_name: settings.list_name,
                    list_id: settings.list_id,
                    item_id: productId,
                    item_name: productTitle,
                    price: price,
                    item_brand: settings.item_brand || null,
                    item_category: settings.category || settings.item_category || 'Uncategorized',
                    item_category2: settings.category2 || settings.item_category2 || 'Uncategorized',
                    item_variant: settings.item_variant || 'Title'
                }]
            }
        };

        dataLayer.push({ ecommerce: null });
        dataLayer.push(customEvent);
        console.log("dataLayer push -> cart_upsell_module_image:", customEvent);
    }

    handleCartUpsellAddToCart(event) {
        const button = event.target.closest('[data-action="add-to-cart"]');
        if (!button || !dataLayer) return;

        const form = button.closest('form');
        if (!form) return;

        // Get product card
        const productCard = button.closest('.cart-drawer__rec-item') ||
                           button.closest('.swiper-slide');

        // Try to get GTM data from data-select-settings first
        const productLink = productCard?.querySelector('[data-action="ga-send-select"]');
        let settings = null;
        if (productLink) {
            try {
                settings = JSON.parse(productLink.dataset.selectSettings);
            } catch (e) {
                // Silent fail
            }
        }

        // Extract product data from form
        const productId = form.dataset.productid;

        // Get GTM data from hidden inputs (fallback)
        const gtmCategory = form.querySelector('input[name="properties[_gtm-category]"]')?.value || settings?.category || settings?.item_category || '';
        const gtmCategory2 = form.querySelector('input[name="properties[_gtm-category2]"]')?.value || settings?.category2 || settings?.item_category2 || '';
        const gtmItemVariant = form.querySelector('input[name="properties[_gtm-item_variant]"]')?.value || settings?.item_variant || 'Default Title';
        const gtmItemBrand = form.querySelector('input[name="properties[_gtm-item_brand]"]')?.value || settings?.item_brand || '';
        const gtmListId = form.querySelector('input[name="properties[_gtm-list_id]"]')?.value || settings?.list_id || '';
        const gtmListName = form.querySelector('input[name="properties[_gtm-list_name]"]')?.value || settings?.list_name || '';

        // Extract title
        const productTitle = productCard?.querySelector('.product-card__title')?.textContent?.trim() || settings?.item_name || '';

        // Extract price - try multiple methods
        let price = 0;

        // First, try to get from settings
        if (settings?.price && settings.price > 0) {
            price = settings.price;
        } else {
            // Fallback: extract from DOM
            const priceElement = productCard?.querySelector('.priceItem--regular');
            if (priceElement) {
                // Parse formatted price like "$29.95" or "29.95"
                const priceText = priceElement.textContent.trim();
                const priceMatch = priceText.match(/[\d,]+\.?\d*/);
                if (priceMatch) {
                    price = parseFloat(priceMatch[0].replace(/,/g, ''));
                }
            }
        }

        const customEvent = {
            event: 'cart_upsell_module_add_to_cart',
            ecommerce: {
                currency: ShopifyAnalytics.meta.currency,
                value: price,
                items: [{
                    item_id: productId,
                    item_name: productTitle,
                    item_variant: gtmItemVariant,
                    item_brand: gtmItemBrand,
                    category: gtmCategory,
                    category2: gtmCategory2,
                    price: price,
                    quantity: 1,
                    list_id: gtmListId,
                    list_name: gtmListName
                }]
            }
        };

        dataLayer.push({ ecommerce: null });
        dataLayer.push(customEvent);
        console.log("dataLayer push -> cart_upsell_module_add_to_cart:", customEvent);
    }

    handlePDPUpsellAddToCart(event) {
        const button = event.target.closest('[data-action="add-to-cart"]');
        if (!button || !dataLayer) return;

        const form = button.closest('form');
        if (!form) return;

        // Extract product data from form
        const productId = form.dataset.productid;

        // Get GTM data from hidden inputs
        const gtmCategory = form.querySelector('input[name="properties[_gtm-category]"]')?.value || '';
        const gtmCategory2 = form.querySelector('input[name="properties[_gtm-category2]"]')?.value || '';
        const gtmItemVariant = form.querySelector('input[name="properties[_gtm-item_variant]"]')?.value || '';
        const gtmItemBrand = form.querySelector('input[name="properties[_gtm-item_brand]"]')?.value || '';
        const gtmListId = form.querySelector('input[name="properties[_gtm-list_id]"]')?.value || '';
        const gtmListName = form.querySelector('input[name="properties[_gtm-list_name]"]')?.value || '';

        // Get product card to extract title and price (PDP complementary products layout)
        const productCard = button.closest('.product-info__complementary__content__wrapper');

        const productTitle = productCard?.querySelector('.product-info__complementary__title-price__wrapper .u-p2')?.textContent?.trim() || '';

        const priceElement = productCard?.querySelector('.product-info__price');
        const priceText = priceElement?.querySelector('[data-price]')?.dataset?.price ||
                         priceElement?.textContent?.trim() || '0';
        const price = parseFloat(priceText) / 100 || 0; // Shopify prices are in cents

        const customEvent = {
            event: 'product_upsell_module_add_to_cart',
            ecommerce: {
                currency: ShopifyAnalytics.meta.currency,
                value: price,
                items: [{
                    item_id: productId,
                    item_name: productTitle,
                    item_variant: gtmItemVariant || 'Default Title',
                    item_brand: gtmItemBrand,
                    category: gtmCategory,
                    category2: gtmCategory2,
                    price: price,
                    quantity: 1,
                    list_id: gtmListId,
                    list_name: gtmListName
                }]
            }
        };

        dataLayer.push({ ecommerce: null });
        dataLayer.push(customEvent);
        console.log("dataLayer push -> product_upsell_module_add_to_cart:", customEvent);
    }

    buildEcommerce(cartItems) {
        const items = [];
        let totalPrice = 0;

        cartItems.forEach((item) => {
            const price = typeof item.price === "number" ? item.price / 100 : Number(item.price);
            totalPrice += price * item.quantity;

            // Only query DOM if properties are missing (fallback)
            const domElement = (!item.properties?.["_gtm-category"] || !item.properties?.["_gtm-item_variant"])
                ? document.querySelector(`.cart-item[data-gtm-id='${item.view_key || item.key}'`)
                : null;

            const product = {
                'item_id': item.sku || "",
                'item_name': item.untranslated_product_title || item.title || "",
                'item_variant': item.properties?.["_gtm-item_variant"] || item.untranslated_variant_title || domElement?.dataset?.gtmVariant || "Default Title",
                'price': price,
                'quantity': item.quantity,
                'category': item.properties?.["_gtm-category"] || domElement?.dataset?.gtmCategory || "",
                'category2': item.properties?.["_gtm-category2"] || domElement?.dataset?.gtmCategory2 || "",
                'item_brand': item.properties?.["_gtm-item_brand"] || item.vendor || "",
                'list_id': item.properties?.["_gtm-list_id"] || domElement?.dataset?.gtmListId || "",
                'list_name': item.properties?.["_gtm-list_name"] || domElement?.dataset?.gtmListName || ""
            }

            items.push(product);
        });

        return {
            'value': totalPrice,
            'currency': ShopifyAnalytics.meta.currency,
            'items': items
        }
    }

    getDataFromRequest(cartItems, request) {
        let body = request?.body || null;
        if (!body) return cartItems;

        body = JSON.parse(body);
        const quantity = body["quantity"] || 1;
        if (quantity) cartItems[0].quantity = Number(quantity);

        return cartItems;
    }
}

// Expose instance globally for other scripts to access
window.gTagEvents = new gTagEvents();